import { AnimatePresence } from "framer-motion";
import { FC, ReactNode } from "react";

interface AnimatePresenceProviderProps {
  children: ReactNode;
}

export const AnimatePresenceProvider: FC<AnimatePresenceProviderProps> = ({
  children,
}) => {
  return <AnimatePresence mode="wait">{children}</AnimatePresence>;
};
